var initHeader2024 = require('./initHeader2024');
var initHeader2025 = require('./initHeader2025');

module.exports = function () {
    initHeader2024();
    initHeader2025();
};